/**
 * Findings queries: read the project's latest inspection findings via GET /v1/findings.
 * The route is in the contract (2026-09-17); compliance and edit mutations are not.
 */
import { useQuery } from '@tanstack/react-query';
import { typedClient, throwOnServerError, type components } from '../../api';

export function useFindings(projectId: string) {
  return useQuery<components['schemas']['FindingView'][]>({
    queryKey: ['findings', projectId],
    queryFn: async () => {
      const response = await typedClient.GET('/v1/findings', {
        params: { query: { project_id: projectId } },
      });
      throwOnServerError(response);
      return response.data ?? [];
    },
  });
}
